import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import discordImage from "../../../../assets/images/svgs/discord-round-color-icon.png";
import facebookImage from "../../../../assets/images/svgs/icons8-facebook-48.png";
import instagramImage from "../../../../assets/images/svgs/icons8-instagram-48.png";
import tiktokImage from "../../../../assets/images/svgs/icons8-tiktok-48.png";
import youtubeImage from "../../../../assets/images/svgs/icons8-youtube-48.png";
import Button from "../../../../components/button/Button";
import TextInput from "../../../../components/inputs/textInput/TextInput";
import Loader from "../../../../components/loader/Loader";
import SettingsPagesContainer from "../../../../components/settingsPagesContainer/SettingsPagesContainer";
import TextWrapper from "../../../../components/textWrapper/TextWrapper";
import {
  fetchSocialMedia,
  updateSocialMedia,
} from "../../../../features/socialMedia/socialMediaSlice";
import styles from "./allSocialMedia.module.css";

const SOCIAL_MEDIA_FIELDS = [
  {
    key: "facebook",
    label: "Facebook",
    image: facebookImage,
  },
  {
    key: "instagram",
    label: "Instagram",
    image: instagramImage,
  },
  {
    key: "tiktok",
    label: "TikTok",
    image: tiktokImage,
  },
  {
    key: "youtube",
    label: "YouTube",
    image: youtubeImage,
  },
  {
    key: "discord",
    label: "Discord",
    image: discordImage,
    imageClassName: styles.iconImage,
  },
];

const AllSocialMedia = () => {
  const [socialLinks, setSocialLinks] = useState({
    facebook: "",
    instagram: "",
    tiktok: "",
    youtube: "",
    discord: "",
  });

  const dispatch = useDispatch();

  const { list, fetchStatus, error } = useSelector(
    (state) => state.socialMedia
  );

  useEffect(() => {
    dispatch(fetchSocialMedia());
  }, [dispatch]);

  const handleSubmitAll = () => {
    Object.entries(socialLinks).forEach(([name, link]) => {
      if (link.trim()) {
        dispatch(updateSocialMedia({ name, data: { link } }));
      }
    });
  };

  return (
    <SettingsPagesContainer
      title={"التحكم في السوشال ميديا"}
      fullHeight
      displayContainerClassName={styles.displayContainer}
    >
      {fetchStatus === "loading" ? (
        <div className={styles.loaderContainer}>
          <Loader />
        </div>
      ) : (
        <div className={styles.formContainer}>
          <div className={styles.fieldsWrapper}>
            {SOCIAL_MEDIA_FIELDS.map((field) => (
              <div key={field.key} className={styles.socialMediaInputWrapper}>
                <div className={styles.iconWrapper}>
                  <img
                    src={field.image}
                    alt={field.label}
                    className={field.imageClassName || ""}
                  />
                </div>
                <TextInput
                  height="52px"
                  width="100%"
                  borderRadius="12px"
                  placeHolder={
                    list?.find((item) => item?.name === field.key)?.link
                  }
                  bgColor={"grey"}
                  bordered
                  value={socialLinks[field.key]}
                  onChange={(e) =>
                    setSocialLinks((prev) => ({
                      ...prev,
                      [field.key]: e.target.value,
                    }))
                  }
                />
              </div>
            ))}
          </div>
          {error && (
            <div className={styles.errorState}>
              <TextWrapper textStyle="textSmall">{error}</TextWrapper>
            </div>
          )}
          <div className={styles.submitButtonWrapper}>
            <Button
              size="bigSize"
              variant="surfaceVariant"
              functionallity={handleSubmitAll}
            >
              <TextWrapper textStyle="textMid">
                التعديل على اللينكات
              </TextWrapper>
            </Button>
          </div>
        </div>
      )}
    </SettingsPagesContainer>
  );
};

export default AllSocialMedia;
